import { render, staticRenderFns } from "./DirectiveActivityView.vue?vue&type=template&id=1dc4c0b2"
import script from "./DirectiveActivityView.vue?vue&type=script&lang=js"
export * from "./DirectiveActivityView.vue?vue&type=script&lang=js"
import style0 from "./DirectiveActivityView.vue?vue&type=style&index=0&id=1dc4c0b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports